
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { Client } from '@/types/client';

interface StatusSectionProps {
  form: UseFormReturn<Client>;
}

export const StatusSection: React.FC<StatusSectionProps> = ({ form }) => {
  return (
    <div className="bg-white p-6 border border-gray-200 rounded-lg">
      <h3 className="text-lg font-montserrat font-semibold text-primary-700 mb-4 flex items-center">
        <div className="w-2 h-2 bg-primary-500 rounded-full mr-2" />
        Status
      </h3>
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="is_active"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border border-gray-200 p-4">
              <div className="space-y-0.5">
                <FormLabel className="text-gray-700 font-medium">Status do Cliente</FormLabel>
                <div className="text-sm text-gray-500">
                  Ativar ou desativar o cliente no sistema
                </div>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="email_canal_enabled"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border border-gray-200 p-4">
              <div className="space-y-0.5">
                <FormLabel className="text-gray-700 font-medium">Habilitar canal de email</FormLabel>
                <div className="text-sm text-gray-500">
                  Permite espelhar lotes de WhatsApp em lotes de email.
                </div>
              </div>
              <FormControl>
                <Switch
                  checked={field.value ?? false}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
